<template>
<div>
  <el-tabs v-model="activeName" @tab-click="handleClick" :stretch=true :tab-position="tabPosition">
    <el-tab-pane label="Προσωπικά Στοιχεία" name="first">
      <personal-details :personalDetails="workingApplication.personalDetails"></personal-details>
    </el-tab-pane>
    <el-tab-pane label="Τίτλος Σπουδών" name="second" v-if="!isReappraisal">
      <titles :application="workingApplication"></titles>
    </el-tab-pane>
    <el-tab-pane label="Συνυποβολή Τίτλου" name="third"
      v-if='isReappraisal && workingApplication.degreeType === "bachelor" && workingApplication.consideration === true'>
      <title-consideration :application="workingApplication"></title-consideration>
    </el-tab-pane>
    <el-tab-pane label="Ιστορικό" name="fourth">
      <history-line :applicationHistory="history"></history-line>
    </el-tab-pane>
    <el-tab-pane label="Επισυναπτόμενα" name="fifth">
      <attached-documents :attachedDocumentsTable="attachedDocumentsTable" :neededDocuments="workingApplication.neededDocuments" :appId="workingApplication.id"> </attached-documents>
    </el-tab-pane>
    <el-tab-pane label="Σχετική αίτηση" name="seventh" v-if="isReappraisal">
        <relevant-app :relevantApp="workingApplication.relevantApplication"></relevant-app>
    </el-tab-pane>
    <el-tab-pane label="Αποτέλεσμα Επεξεργασίας" name="eighth">
      <el-form ref="ref1" :inline='false' :model="workingApplication" label-width="170px"
        v-loading='loadingWorkingApplication' label-position="right">
        <!-- <span shadow="hover" class="proposal">
          <el-form-item label="Eισήγηση Προέδρου:">
            {{presidentProposal}}
          </el-form-item>
        </span> -->
        <el-form-item v-if="!isReappraisal" label="Ειδικός Εισηγητής:">
          <span v-html="specialProponentProposal"></span>
        </el-form-item>
        <el-form-item v-if="isReappraisal" label="Σημείωση Αντιπροέδρου:">
          <span>{{viceNote}}</span>
        </el-form-item>
        <hr v-if='fromConsultant'>
        <el-form-item v-if='fromConsultant' label="Ακαδημαικός Σύμβουλος:">{{consultantProposal}}</el-form-item>
        <hr>
        <el-form-item label="Εκτελεστική επιτροπή:">
          <el-table :data="membersDecisions" style="width: 100%">
            <el-table-column  label="Αποφάσεις Μελών Επιτροπής">
            <el-table-column label="Όνομα"  width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.firstname }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Επώνυμο"  width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.surname }}</span>
              </template>
            </el-table-column>
             <el-table-column v-if="isReappraisal" label="Πλήρης αποδοχή" align="center" width="150">
                <template slot-scope="scope">
                  <span class="agree-btn" v-if="scope.row.fullyAgreeWithReappraisal === true"> <i class="el-icon-check"></i></span>
                  <span class="disagree-btn" v-if="scope.row.fullyAgreeWithReappraisal === false"> <i class="el-icon-close"></i></span>
                  <span class="pending-btn" v-if="scope.row.fullyAgreeWithReappraisal === null"> <i class="el-icon-minus"></i></span>
                </template>
              </el-table-column>
            <el-table-column v-if="!isReappraisal" label="Αποδοχή πρότασης" align="center">
              <el-table-column label="Εισηγητή"  width="90" align="center">
                <template slot-scope="scope">
                  <span class="agree-btn" v-if="scope.row.agreeWithProponent === true"> <i class="el-icon-check"></i></span>
                  <span class="disagree-btn" v-if="scope.row.agreeWithProponent === false"> <i class="el-icon-close"></i></span>
                  <span class="pending-btn" v-if="scope.row.agreeWithProponent === null"> <i class="el-icon-minus"></i></span>
                </template>
              </el-table-column>
              <el-table-column label="Ακαδημαικού Συμβούλου"  width="110" v-if='fromConsultant' align="center">
                <template slot-scope="scope">
                  <span class="agree-btn" v-if="scope.row.agreeWithAC === true"> <i class="el-icon-check"></i></span>
                  <span class="disagree-btn" v-if="scope.row.agreeWithAC === false"> <i class="el-icon-close"></i></span>
                   <span class="pending-btn" v-if="scope.row.agreeWithAC === null"> <i class="el-icon-minus"></i></span>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="Εισήγηση">
              <template slot-scope="scope">
                <span>{{ scope.row.proposal }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Υποβολή"  width="85" align="center">
              <template slot-scope="scope">
                <span class="done-btn" v-if="scope.row.finalize === true"> <i class="el-icon-check"></i></span>
                <span class="pending-btn" v-if="scope.row.finalize === false"> <i class="el-icon-edit"></i></span>
                <!-- <el-button type="success" icon="el-icon-check" size="mini" round v-if="scope.row.finalize">Οριστική</el-button>
                <el-button type="warning" icon="el-icon-edit" size="mini" round v-if="!scope.row.finalize">Προσωρινή</el-button> -->
              </template>
            </el-table-column>
            </el-table-column>
          </el-table>
        </el-form-item>
        <hr>
        <el-form-item v-if="proposalFound && isReappraisal">Εισήγηση Εκτελεστικής Επιτροπής
          <el-alert type="warning" title="Υπάρχει εισήγηση της Εκτελεστικής Επιτροπής (στην καρτέλα Επισυναπτόμενα)" show-icon></el-alert>
        </el-form-item>
        <!-- <el-form-item label="Ανεβάστε εισήγηση" v-if="!proposalFound"> -->
        <el-form-item label="Ανεβάστε εισήγηση" v-if="isReappraisal && (!proposalFound || this.workingApplication.attachedDocuments.slice(-1)[0].uploadedBy === this.currentUser.id)">
        <el-upload v-loading="this.uploading"
          class="upload-demo"
          ref="uploadReappraisalProposal"
          accept=".pdf, .doc"
          :file-list="boardAttachments"
          :http-request="addAttachment"
          :on-remove="handleRemove"
          :on-preview="viewPdf"
          :before-remove="handleBeforeRemove"
          action=""
          :limit=1
          :auto-upload="true"
          :show-file-list='true'>
          <el-button slot="trigger" size="small" type="primary">Ανέβασμα</el-button>
          <div class="el-upload__tip" slot="tip">** Μ Ο Ν Ο για να ανεβάσετε εισήγηση της Ειδ. Επιτρ. Επανεξέτασης ( αρχείο pdf μεγέθους μέχρι 12MB)</div>
        </el-upload>
      </el-form-item>
        <el-form-item v-if="isReappraisal" label="Πλήρης αποδοχή">
          <el-tooltip class="item" effect="dark" content="Πλήρης αποδοχή ή όχι του αιτήματος επανεξέτασης" placement="top-start">
          <el-switch v-model="myJudgment.fullyAgreeWithReappraisal" v-if='!myJudgment.finalize' active-text="Ναι" inactive-text="Όχι"></el-switch>
            <span class="agree-btn" v-if="myJudgment.finalize && myJudgment.fullyAgreeWithReappraisal"> <i class="el-icon-check"></i></span>
            <span class="disagree-btn" v-if="myJudgment.finalize && !myJudgment.fullyAgreeWithReappraisal"> <i class="el-icon-close"></i></span>
          </el-tooltip>
        </el-form-item>
        <el-form-item v-if="!isReappraisal" label="Αποδοχή πρότασης:">
          <el-form-item label="Εισήγητη:">
            <el-switch v-model="myJudgment.agreeWithProponent" v-if='!myJudgment.finalize' active-text="Ναι" inactive-text="Όχι"></el-switch>
            <span class="agree-btn" v-if="myJudgment.finalize && myJudgment.agreeWithProponent"> <i class="el-icon-check"></i></span>
            <span class="disagree-btn" v-if="myJudgment.finalize && !myJudgment.agreeWithProponent"> <i class="el-icon-close"></i></span>
          </el-form-item>
          <br v-if='fromConsultant'>
          <el-form-item label="Ακαδημαικoύ Συμβούλου:" v-if='fromConsultant'>
            <el-switch v-model="myJudgment.agreeWithAC" active-text="Ναι" inactive-text="Όχι" v-if="!myJudgment.finalize"></el-switch>
            <span class="agree-btn" v-if="myJudgment.finalize && myJudgment.agreeWithAC"> <i class="el-icon-check"></i></span>
            <span class="disagree-btn" v-if="myJudgment.finalize && !myJudgment.agreeWithAC"> <i class="el-icon-close"></i></span>
          </el-form-item>
        </el-form-item>
        <hr>
        <br>
        <el-form-item label="Εισήγηση:">
          <el-input type="textarea" class="biggest"
            placeholder="Η εισήγηση είναι υποχρεωτική σε περίπτωση διαφωνίας με τον Ειδικό Εισηγητή και/η με τον Ακαδημαϊκό Σύμβουλο καθώς και σε περίπτωση εμμονής/μερικής ικανοποίησης του αιτήματος επανεξέτασης"
            v-model="myJudgment.proposal" :autosize="{ minRows: 3, maxRows: 10 }" @change="proposalChanged" v-if="!myJudgment.finalize"></el-input>
          <span v-if="myJudgment.finalize">{{ myJudgment.proposal }}</span>
        </el-form-item>
        <br>
        <el-form-item label="Εσωτερικό Σχόλιο:">
          <el-input placeholder="Εισάγετε προαιρετικά το σχόλιό σας για εσωτερική κατανάλωση"
            type="textarea" class="biggest" :autosize="{ minRows: 3, maxRows: 10}"
            v-model="myJudgment.comment" v-if="!myJudgment.finalize">
          </el-input>
          <span v-if="myJudgment.finalize">{{ myJudgment.comment }}</span>
        </el-form-item>
        <div style="text-align: center">
          <el-button size="mini" type="primary" round @click="tempSave" icon="el-icon-edit"
            v-if="!myJudgment.finalize">Προσωρινή Αποθήκευση
          </el-button>
          <el-button size="mini" type="danger" round @click="finalSave" icon="el-icon-check"
            v-if="!myJudgment.finalize" :disabled="canDisagree">Ολοκλήρωση
          </el-button>
          <el-button size="mini" type="warning" icon="el-icon-caret-left" plain round
            @click="releaseApplication" :disabled="canDisagree"
            v-if="!isReappraisal && !myJudgment.finalize && !myJudgment.agreeWithProponent"> Επιστροφή στον Εισηγητή
          </el-button>
          <el-tag size="large" type="danger" round v-if="myJudgment.finalize">
            Οριστικοποιημένη Εισήγηση
          </el-tag>
        </div>
        <hr>
        <proposals></proposals>
        <internalComments></internalComments>
      </el-form>
    </el-tab-pane>
  </el-tabs>
</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import axios from 'axios'
import internalComments from '../common/internalComments'
import Proposals from '../common/Proposals'
import PersonalDetails from '../common/PersonalDetails'
import Titles from '../common/Titles'
import TitleConsideration from '../common/TitleConsideration'
import HistoryLine from '../common/HistoryLine'
import AttachedDocuments from '../common/AttachedDocuments'
import sharedMethods from '../common/sharedMethods.js'
import RelevantApp from '../common/RelevantApp'
export default {
  components: {
    PersonalDetails,
    Titles,
    TitleConsideration,
    HistoryLine,
    internalComments,
    AttachedDocuments,
    Proposals,
    RelevantApp
  },
  mixins: [sharedMethods],
  data () {
    return {
      tabPosition: 'top',
      activeName: 'fifth',
      attachments: [],
      uploading: false
    }
  },
  methods: {
    addAttachment (file, fileList) {
      this.attachments.push(file.file)
      let self = this
      return this.getData(file.file).then(data => {
        self.fileData = data
        self.fileName = file.file.name
        self.newAttachment()
      })
    },
    newAttachment () {
      let payload = {
        file: this.fileData, // Το τελικο αρχείο προς ψηφιακή υπογραφή σε base64
        name: this.fileName, // Το όνομα του αρχείου
        type: 25,
        uuid: this.currentUser.id
      }
      this.uploading = true
      axios.post(
        `${this.BASE_URL}/users/${this.currentUser.id}/applications/${this.workingApplication.id}/attachments`, payload
      ).then(response => {
        let id = response.data.data.id
        // file.file.id = id
        this.uploading = false
        this.frontEndSuccessMsg('Το αρχείο επισυνάφθηκε με επιτυχία')
        let boardAttached = this.boardAttachments.slice(0)
        boardAttached[boardAttached.length] = {type: payload.type, name: payload.name, uid: payload.uuid, id: id}
        this.$store.dispatch('SET_BOARD_ATTACHMENTS', boardAttached)
      }).catch((err) => {
        // this.frontEndError('Σφάλμα κατά την επισύναψη του αρχείου')
        this.catchError(err)
      })
      // this.$store.dispatch('SET_WORKING_APPLICATION_ATTACHMENTS', this.workingApplication.attachedDocuments)
    },
    handleBeforeRemove (file, fileList) {
      return this.$confirm(`Να αφαιρεθεί το ${file.name}？`)
    },
    handleRemove (file, fileList) {
      this.attachments = []
      this.fileData = ''
      this.fileName = ''
      return axios.delete(
        `${this.BASE_URL}/users/${this.currentUser.id}/applications/${this.workingApplication.id}/attachments/${file.id}`
      ).then(response => {
        this.$store.dispatch('SET_BOARD_ATTACHMENTS', this.boardAttachments.filter(attachment => attachment.id !== file.id))
      }).catch(err => {
        this.backendError(err)
        throw err
      })
    },
    viewPdf (file) {
      const base64Data = encodeURI(this.fileData)
      this.openPdfWindow(file.name, base64Data)
    },
    getData (file) {
      return new Promise((resolve, reject) => {
        const fReader = new FileReader()
        let base64Pdf
        fReader.onload = (fileLoadedEvent) => {
          base64Pdf = fileLoadedEvent.target.result
          resolve(base64Pdf.split(',')[1])
        }
        fReader.readAsDataURL(file)
      })
    },
    handleClick (tab, event) {
    },
    catchError (err) {
      this.backendError(err)
      throw err
    },
    releaseApplication () {
      this.$confirm(this.backToProponentMessage,
        'Προειδοποίηση', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Άκυρο',
          type: 'warning'
        }).then(() => {
        axios.put(
          `${this.BASE_URL}/executiveboardmembers/uid/applications/${this.workingApplication.id}/final`,
          {
            judgment: {
              comment: this.myJudgment.comment,
              agreeWithProponent: this.myJudgment.agreeWithProponent,
              agreeWithAC: this.myJudgment.agreeWithAC,
              proposal: this.myJudgment.proposal,
              finalize: true
            },
            nextRole: 'Proponent'
          }
        ).then((response) => {
          this.$store.dispatch('LOAD_ASSIGNED_APPLICATIONS', this.activeLane)
          this.$emit('closeDialogEvent')
          this.frontEndSuccessMsg('Η αίτηση επέστρεψε στον εισηγητή')
        }).catch(err => {
          this.frontEndError('Σφάλμα κατά την επιστροφή αίτησης στον εισηγητή')
          this.catchError(err)
        })
      })
    },
    finalSave () {
      let payload
      if (!this.isReappraisal) {
        payload = {
          comment: this.myJudgment.comment,
          agreeWithProponent: this.myJudgment.agreeWithProponent === null
            ? false
            : this.myJudgment.agreeWithProponent,
          agreeWithAC: this.myJudgment.agreeWithAC === null
            ? this.fromConsultant === true
              ? false
              : null
            : this.myJudgment.agreeWithAC,
          proposal: this.myJudgment.proposal,
          finalize: true
        }
      } else if (this.isReappraisal) {
        payload = {
          comment: this.myJudgment.comment,
          fullyAgreeWithReappraisal: this.myJudgment.fullyAgreeWithReappraisal,
          proposal: this.myJudgment.proposal,
          finalize: true
        }
      }
      this.$confirm(this.saveMessage,
        'Προειδοποίηση', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Άκυρο',
          type: 'warning'
        }).then(() => {
        axios.put(
          `${this.BASE_URL}/executiveboardmembers/uid/applications/${this.workingApplication.id}/final`,
          {
            judgment: payload,
            nextRole: 'Viewer'
          }
        ).then((response) => {
          this.$store.dispatch('LOAD_ASSIGNED_APPLICATIONS', this.activeLane)
          this.$emit('closeDialogEvent')
          this.frontEndSuccessMsg('Τα δεδομένα αποθηκεύτηκαν με επιτυχία')
        }).catch(err => {
          this.frontEndError('Σφάλμα κατά την οριστική αποθήκευση')
          this.catchError(err)
        })
      })
    },
    tempSave () {
      let payload
      if (!this.isReappraisal) {
        payload = {
          comment: this.myJudgment.comment,
          agreeWithProponent: this.myJudgment.agreeWithProponent === null
            ? false
            : this.myJudgment.agreeWithProponent,
          agreeWithAC: this.myJudgment.agreeWithAC === null
            ? this.fromConsultant === true
              ? false
              : null
            : this.myJudgment.agreeWithAC,
          proposal: this.myJudgment.proposal,
          finalize: false
        }
      } else if (this.isReappraisal) {
        payload = {
          comment: this.myJudgment.comment,
          fullyAgreeWithReappraisal: this.myJudgment.fullyAgreeWithReappraisal,
          proposal: this.myJudgment.proposal,
          finalize: false
        }
      }
      axios.put(
        `${this.BASE_URL}/executiveboardmembers/uid/applications/${this.workingApplication.id}/temp`,
        {
          judgment: payload,
          nextRole: ''
        }
      ).then((response) => {
        this.frontEndSuccessMsg('Τα δεδομένα αποθηκεύτηκαν με επιτυχία')
      }).catch(err => {
        this.frontEndError('Σφάλμα κατά την προσωρινή αποθήκευση')
        this.catchError(err)
      })
    },
    proposalChanged () {
      return this.myJudgment.proposal
    }
  },
  computed: {
    isReappraisal () {
      return this.workingApplication.applicationType === 'reappraisal'
    },
    attachedDocumentsTable () {
      return this.workingApplication.attachedDocuments.slice(0).map(doc =>
        ({name: doc.name,
          type: doc.type,
          date: doc.date,
          applicantComment: doc.applicantComment,
          precheckerChecked: doc.precheckerChecked,
          precheckerComment: doc.precheckerComment,
          id: doc.id
        })
      )
    },
    canDisagree () {
      if (this.isReappraisal) {
        // if (!this.proposalFound) {
        //   return true
        // } else if (this.proposalFound && this.myJudgment.fullyAgreeWithReappraisal === null) {
        if (this.proposalFound && this.myJudgment.fullyAgreeWithReappraisal === null) {
          return true
        } else if (this.proposalFound && this.myJudgment.fullyAgreeWithReappraisal === false && ['', null, undefined].includes(this.myJudgment.proposal)) {
          return true
        } else return false
      } else if (!this.isReappraisal) {
        if (this.fromConsultant) {
          if (this.myJudgment.agreeWithAC === false || this.myJudgment.agreeWithProponent === false || this.myJudgment.agreeWithProponent === null || this.myJudgment.agreeWithAC === null) {
            if (this.myJudgment.proposal === '' || this.myJudgment.proposal === null || this.myJudgment.proposal === undefined) {
              return true
            } else {
              return false
            }
          } else {
            return false
          }
        } else {
          if (this.myJudgment.agreeWithProponent === false || this.myJudgment.agreeWithProponent === null) {
            if (this.myJudgment.proposal === '' || this.myJudgment.proposal === null || this.myJudgment.proposal === undefined) {
              return true
            } else {
              return false
            }
          } else {
            return false
          }
        }
      }
    },
    saveMessage () {
      if (!this.isReappraisal) {
        if (this.fromConsultant) {
          if (this.myJudgment.agreeWithAC === true && this.myJudgment.agreeWithProponent === true) {
            return 'Δηλώσατε συμφωνία με τον Ακαδημαϊκό Σύμβουλο και τον Ειδικό Εισηγητή. Μετά το πέρας της διαδικασίας δεν υπάρχει δυνατότητα αλλαγής της απόφασης.'
          } else if ((this.myJudgment.agreeWithAC === false && this.myJudgment.agreeWithProponent === false) || (this.myJudgment.agreeWithAC === null && this.myJudgment.agreeWithProponent === null)) {
            return 'Δηλώσατε διαφωνία με τον Ακαδημαϊκό Σύμβουλο και τον Ειδικό Εισηγητή. Μετά το πέρας της διαδικασίας δεν υπάρχει δυνατότητα αλλαγής της απόφασης.'
          } else if (this.myJudgment.agreeWithAC === true && this.myJudgment.agreeWithProponent === false) {
            return 'Δηλώσατε συμφωνία με τον Ακαδημαϊκό Σύμβουλο και διαφωνία με τον Ειδικό Εισηγητή. Μετά το πέρας της διαδικασίας δεν υπάρχει δυνατότητα αλλαγής της απόφασης.'
          } else if (this.myJudgment.agreeWithAC === false && this.myJudgment.agreeWithProponent === true) {
            return 'Δηλώσατε διαφωνία με τον Ακαδημαϊκό Σύμβουλο και συμφωνία τον Ειδικό Εισηγητή. Μετά το πέρας της διαδικασίας δεν υπάρχει δυνατότητα αλλαγής της απόφασης.'
          }
        } else {
          return this.myJudgment.agreeWithProponent ? 'Δηλώσατε συμφωνία με τον Ειδικό Εισηγητή. Μετά το πέρας της διαδικασίας δεν υπάρχει δυνατότητα αλλαγής της απόφασης.'
            : 'Δηλώσατε διαφωνία με τον Ειδικό Εισηγητή. Μετά το πέρας της διαδικασίας δεν υπάρχει δυνατότητα αλλαγής της απόφασης.'
        }
      } else if (this.isReappraisal) {
        if (this.myJudgment.fullyAgreeWithReappraisal === true) {
          return 'Δηλώσατε πλήρη αποδοχή του αιτήματος επανεξέτασης. Μετά το πέρας της διαδικασίας δεν υπάρχει δυνατότητα αλλαγής της απόφασης.'
        } else return 'Δηλώσατε εμμονή/ μερική ικανοποίηση του αιτήματος επανεξέτασης. Μετά το πέρας της διαδικασίας δεν υπάρχει δυνατότητα αλλαγής της απόφασης.'
      }
    },
    backToProponentMessage () {
      return 'Επιλέξατε να επιστρέψετε την αίτηση στον Ειδικό Εισηγητή μετά το πέρας της διαδικασίας δεν υπάρχει δυνατότητα αλλαγής της απόφασης'
    },
    membersDecisions () {
      return this.workingApplication.applicationHistory[this.workingApplication.applicationHistory.length - 1].judgment.filter(item => item.uid !== this.currentUser.id)
    },
    myJudgment () {
      let judg = this.workingApplication.applicationHistory[this.workingApplication.applicationHistory.length - 1].judgment.find(item => item.uid === this.currentUser.id)
      return judg === undefined || judg === null
        ? { agreeWithAC: null,
          agreeWithProponent: null,
          fullyAgreeWithReappraisal: null,
          comment: '',
          date: '',
          proposal: '',
          finalize: false,
          uid: null} : judg
    },
    presidentProposal () {
      let presProposal = this.workingApplication.applicationHistory.slice(0).reverse().find(item => item.applicationStatus.includes('presidentW')).judgment
      return presProposal !== undefined && presProposal !== null
        ? presProposal.internalComment : 'Δεν βρέθηκε εισήγηση του Προέδρου'
    },
    viceNote () {
      let note = this.workingApplication.applicationHistory.slice(0).reverse().find(step => step.applicationStatus === 'viceW_Prechecker')
        ? this.workingApplication.applicationHistory.slice(0).reverse().find(step => step.applicationStatus === 'viceW_Prechecker').judgment
        : null
      return note !== undefined && note !== null
        ? note.internalComment : 'Δεν βρέθηκε σημείωμα από Αντιπρόεδρο'
    },
    specialProponentProposal () {
      let propProposal = this.workingApplication.applicationHistory.slice(0).reverse().find(step => step.applicationStatus === 'proponentW_President' || step.applicationStatus === 'proponentW_Board' || step.applicationStatus === 'proponentW_Admin')
      return propProposal !== undefined && propProposal !== null
        ? propProposal.judgment.proposal : 'Δεν βρέθηκε εισήγηση Εισηγητή'
    },
    consultantProposal () {
      let conProp = this.workingApplication.applicationHistory.slice(0).reverse().find(item => item.applicationStatus.includes('consultantW_Proponent'))
      return conProp ? conProp.judgment.proposal : 'Δεν βρέθηκε εισήγηση Ακαδημαικού Συμβούλου'
    },
    ...mapGetters({ currentUser: 'currentUser' }),
    ...mapState([
      'internalComments',
      'proposals',
      'boardAttachments',
      'history',
      'activeLane',
      'assignedApplications',
      'workingApplication',
      'showWorkingApplication',
      'pendingNotifications',
      'loadingAssignedApplications',
      'loadingWorkingApplication',
      'BASE_URL'
    ]),
    fromConsultant () {
      return this.workingApplication.applicationHistory[this.workingApplication.applicationHistory.length - 2].applicationStatus === 'consultantW_Proponent'
    },
    proposalFound () {
      return this.workingApplication.attachedDocuments.slice(0).find(step => step.type === 25) || this.attachments.length !== 0
    }
  },
  watch: {
    comment: (newComment, oldComment) => {
      this.comment = newComment
    },
    workingApplication: function (newData, oldData) {
      this.activeName = 'fifth'
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form-item__content {
  line-height: 20px;
}
.el-form-item__label {
    text-align: right;
    float: left;
    font-size: 14px;
    color: #606266;
    line-height: 20px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
.agree-btn {
    background-color: #67c23a;
    border-radius: 20px;
    color: #fff;
    display: inline-block;
    font-size: 14px;
    height: 26px;
    line-height: 26px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #fff;
}
.disagree-btn {
    background-color: red;
    border-radius: 20px;
    color: #fff;
    display: inline-block;
    font-size: 14px;
    height: 26px;
    line-height: 26px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #fff;
}
.done-btn {
    background-color: #67c23a;
    border-radius: 20px;
    color: #fff;
    display: inline-block;
    font-size: 14px;
    height: 26px;
    line-height: 26px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #fff;
}
.pending-btn {
    background-color: orange;
    border-radius: 20px;
    color: #fff;
    display: inline-block;
    font-size: 14px;
    height: 26px;
    line-height: 26px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #fff;
}
.biggest {
  &.el-textarea {
    width: 700px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/roleSpecific/ExecutiveBoardMemberJudgement.vue